exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody {\n    padding: 0;\n    margin: 0;\n    height: 100vh;\n    height: calc(var(--vh, 1vh) * 100);\n}\n.gotmehookd-app {\n    width: 100%;\n    height: 100%;\n}\n", ""]);

// exports
